export default __webpack_public_path__ + "static/media/8.6d7f362e.jpg";